/**
 * @fileoverview TopImageBanner.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState } from 'react'
import DynamicImage from '../ui/DynamicImage'
import { IMG } from '../../assets/Assets'

function TopImageBanner({ title, hImage, lImage }) {

  const [loading, setLoading] = useState(true);

  return (
    <div className='bg-gray-200 w-full h-full rounded-4xl md:rounded-[3rem] flex flex-col mx-auto justify-end items-start relative overflow-hidden'>
      <DynamicImage loading={loading} setLoading={setLoading} LowImage={lImage || IMG.NuwaraEliya10} HighImage={hImage || IMG.NuwarEliya}  />
      
      {title && (
        <div className='absolute bottom-0 left-0 w-full p-6 md:p-10 bg-linear-to-t from-black/70 to-transparent'>
            <h1 className='text-2xl md:text-4xl font-bold text-white'>{title}</h1>
        </div>
      )}
    </div>
  )
}

export default TopImageBanner